export default __webpack_public_path__ + "static/media/meatslabs.fce8e139.jpg";